import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonRow, IonTitle, IonToast } from '@ionic/react';
import { addCircle, arrowBack, arrowDown, arrowUp, removeCircle, trash } from 'ionicons/icons';
import React, { createRef, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { alterarBalcao, requestService } from '../../../../../Utils/Services';
import OrdensProdutosCompor from '../OrdensProdutosCompor/OrdensProdutosCompor';

type Props = {
  projetoid: string;
  listaInicial: any[];
  dadosComandas: any;
  dadosEmpresa: any;
  onClose: () => void;
  onConfirm: (attrs: any) => void;
};

const AlterarProdutosModal: React.FC<Props> = ({ projetoid, listaInicial, dadosComandas, dadosEmpresa, onClose, onConfirm }) => {
  const history = useHistory<any>();
  const [mostrarAlerta] = useIonAlert();
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState('');

  const [listaItemProdutos, setListaItemProdutos] = useState<any[]>([...listaInicial]);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<string>('0,00');
  const [stateShowCaixa, setStateShowCaixa] = useState(false);

  const contentRef = createRef<HTMLIonContentElement>();
  const contentCatalogoRef = useRef<any>(null);

  useEffect(() => {
    recalcularTotal(listaInicial);
  }, []);

  function recalcularTotal(lista: any[]) {
    const total = lista.reduce((acc: number, item: any) => {
      return acc + (parseFloat(String(item.subtotal).replace(/\./g, '').replace(',', '.')) || 0);
    }, 0);
    setValorTotalProdutos(total.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function adicionarItem(produto: any) {
    if (!produto) return;
    const updated = [...listaItemProdutos, produto];
    setListaItemProdutos(updated);
    recalcularTotal(updated);
    if (window.innerWidth < 768) {
      setTextToast('Item adicionado com sucesso.');
      setShowToast(true);
    }
  }

  function deletarItem(index: number) {
    const updated = listaItemProdutos.filter((_: any, i: number) => i !== index);
    setListaItemProdutos(updated);
    recalcularTotal(updated);
  }

  function alterarQuantidade(index: number, delta: number) {
    const updated = [...listaItemProdutos];
    const item = { ...updated[index] };
    const qtd = parseFloat(String(item.quantidade).replace(/\./g, '').replace(',', '.')) || 1;
    const novaQtd = qtd + delta;
    if (novaQtd < 1) return;
    const valor = parseFloat(String(item.valor).replace(/\./g, '').replace(',', '.')) || 0;
    item.quantidade = novaQtd;
    item.subtotal = (novaQtd * valor).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    updated[index] = item;
    setListaItemProdutos(updated);
    recalcularTotal(updated);
  }

  async function handleSalvar() {
    setShowLoading(true);
    return new Promise<void>((resolve, reject) => {
      requestService(
        alterarBalcao.url.replaceAll('{id}', projetoid.replaceAll(/#/g, '%23')),
        {
          method: alterarBalcao.method,
          headers: [['token', localStorage.getItem('token')]] as any,
          body: JSON.stringify({ produtos: listaItemProdutos, enviado: false }),
          credentials: 'include',
        },
        history,
        (response: any) => {
          setShowLoading(false);
          if (response.dadosPedido?.Attributes) {
            onConfirm(response.dadosPedido.Attributes);
            resolve();
          } else {
            setTextToast('Resposta inválida do servidor.');
            setShowToast(true);
            reject(new Error('Resposta inválida'));
          }
        },
        (error: any) => {
          setShowLoading(false);
          setTextToast(error.message);
          setShowToast(true);
          reject(error);
        }
      );
    });
  }

  const nomeProdutoLabel = (prod: any): string => {
    if (Array.isArray(prod.descricao)) {
      if (prod.tipo === 'pizzas') return `${prod.tamanho} ${prod.quantidadeSabores} SABORES`;
      return prod.categoria || prod.descricao?.[0]?.descricao || '-';
    }
    return prod.descricao || '-';
  };

  const complementosProd = (prod: any) => {
    if (!Array.isArray(prod.descricao)) return [];
    return prod.descricao.slice(1).filter((c: any) => c.descricao);
  };

  function renderLista() {
    if (listaItemProdutos.length === 0) {
      return (
        <div style={{ padding: '12px', color: '#aaa', fontSize: '14px' }}>
          Nenhum item. Use o catálogo para adicionar.
        </div>
      );
    }

    return (
      <IonGrid>
        {listaItemProdutos.map((prod: any, index: number) => (
          <IonRow key={'altprod' + index} style={{ borderBottom: '1px dashed #ddd' }}>
            <IonCol size="9">
              <div style={{ fontWeight: 500, fontSize: '14px' }}>{nomeProdutoLabel(prod)}</div>
              {complementosProd(prod).map((c: any, ci: number) => (
                <div key={'c' + index + ci} style={{ fontSize: '11px', color: '#888', paddingLeft: '8px' }}>
                  {c.categoria === 'Observação' ? `Obs: ${c.descricao}` : `- ${c.descricao}${c.valor && c.valor !== '0,00' ? ` (R$ ${c.valor})` : ''}`}
                </div>
              ))}
              {prod.anotacao && <div style={{ fontSize: '11px', color: '#aaa', fontStyle: 'italic' }}>{prod.anotacao}</div>}
              <div style={{ textAlign: 'right', fontSize: '13px', color: '#444' }}>R$ {prod.subtotal}</div>
            </IonCol>
            <IonCol size="3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', gap: '6px' }}>
              <IonChip style={{ margin: 0, padding: '4px 6px' }}>
                <IonIcon size="large" color="danger" icon={removeCircle} onClick={() => alterarQuantidade(index, -1)} />
                <IonLabel style={{ fontSize: '16px', minWidth: '20px', textAlign: 'center' }}>
                  {Number(prod.quantidade).toLocaleString('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
                </IonLabel>
                <IonIcon size="large" color="success" icon={addCircle} onClick={() => alterarQuantidade(index, 1)} />
              </IonChip>
              <IonButton fill="clear" size="small" onClick={() => {
                mostrarAlerta({
                  backdropDismiss: false, header: 'Remover item',
                  message: 'Deseja <strong>remover</strong> este item?',
                  buttons: [
                    { text: 'Cancelar', role: 'cancel' },
                    { text: 'Confirmar', cssClass: 'primary', handler: () => deletarItem(index) }
                  ],
                });
              }}>
                <IonIcon color="primary" icon={trash} />
              </IonButton>
            </IonCol>
          </IonRow>
        ))}
      </IonGrid>
    );
  }

  return (
    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={onClose} />
          </IonButtons>
          <IonTitle>Alterar Produtos</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent ref={contentRef} fullscreen={false}>
        <IonLoading isOpen={showLoading} message="Aguarde..." />

        <IonGrid style={{ height: '100%', padding: 0, margin: 0 }}>
          <IonRow style={{ height: '100%' }}>

            {/* Coluna catálogo - no mobile alterna com a lista; no desktop sempre visível */}
            <IonCol
              style={{
                height: '100%',
                padding: 0,
                display: (window.innerWidth < 768 && stateShowCaixa) ? 'none' : '',
              }}
              sizeMd="8"
              size="12"
            >
              <div style={{ height: '100%', maxHeight: '100%', overflow: 'auto' }}>
                {/* FAB só aparece no mobile para ir para a lista */}
                {window.innerWidth < 768 && (
                  <IonFab vertical="bottom" horizontal="end" style={{ bottom: '20px', right: '20px' }}>
                    <IonFabButton color="tertiary" onClick={() => setStateShowCaixa(true)}>
                      <IonIcon icon={arrowDown} />
                    </IonFabButton>
                  </IonFab>
                )}
                <OrdensProdutosCompor
                  empresa={dadosEmpresa}
                  disabled={false}
                  adicionarItem={adicionarItem}
                  reload={false}
                  onReloadComplete={() => { }}
                />
              </div>
            </IonCol>

            {/* Coluna lista de itens - no mobile alterna com catálogo; no desktop sempre visível */}
            <IonCol
              style={{
                height: '100%',
                padding: 0,
                display: (window.innerWidth < 768 && !stateShowCaixa) ? 'none' : '',
              }}
              sizeMd="4"
              size="12"
            >
              <div style={{ height: '100%', padding: '10px' }}>
                {/* FAB só aparece no mobile para voltar ao catálogo */}
                {window.innerWidth < 768 && (
                  <IonFab vertical="top" horizontal="end" style={{ top: '20px', right: '20px' }}>
                    <IonFabButton color="tertiary" onClick={() => setStateShowCaixa(false)}>
                      <IonIcon icon={arrowUp} />
                    </IonFabButton>
                  </IonFab>
                )}

                <IonCard style={{ margin: 0, height: '100%' }}>
                  <IonCardContent style={{ height: '100%' }}>
                    <IonGrid style={{ padding: 0, margin: 0 }}>
                      <IonRow style={{ borderBottom: '1px solid grey', fontSize: '22px' }}>
                        <IonCol style={{ padding: 0, margin: 0 }}>
                          <IonLabel><b>Lista de itens</b></IonLabel>
                        </IonCol>
                      </IonRow>
                    </IonGrid>

                    <div style={{ height: 'calc(100% - 160px)', overflowY: 'auto', marginTop: '8px' }}>
                      {renderLista()}
                    </div>

                    <div style={{ position: 'absolute', bottom: '10px', left: 0, right: 0, padding: '0 10px' }}>
                      <IonGrid style={{ padding: 0, margin: 0 }}>
                        <IonRow style={{ fontSize: '18px', marginBottom: '4px' }}>
                          <IonCol style={{ padding: 0 }} size="6"><IonLabel><b>Subtotal</b></IonLabel></IonCol>
                          <IonCol style={{ padding: 0, textAlign: 'right' }} size="6">
                            <IonLabel><b>R$ {valorTotalProdutos}</b></IonLabel>
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                      <IonButton
                        expand="block"
                        style={{ height: '46px', fontSize: '18px' }}
                        onClick={handleSalvar}
                      >
                        Salvar
                      </IonButton>
                      <IonButton
                        expand="block"
                        fill="outline"
                        color="medium"
                        style={{ height: '46px', fontSize: '18px' }}
                        onClick={onClose}
                      >
                        Cancelar
                      </IonButton>
                    </div>
                  </IonCardContent>
                </IonCard>
              </div>
            </IonCol>

          </IonRow>
        </IonGrid>

        <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
      </IonContent>
    </>
  );
};

export default AlterarProdutosModal;
